export default "__VITE_ASSET__TH8KG0dR__"